<template>
    <div class="reminders">
        <b-container fluid>
            <b-row>
                <b-col>
                    <AgGridVue
                        :style="`width: calc(100% - 0px); height: calc(100vh - 235px)`"
                        class="ag-theme-alpine"
                        :columnDefs="columnDefs"
                        :rowData="reminders"
                        :defaultColDef="defaultColDef"
                        :suppressColumnVirtualisation="false"
                        @grid-ready="onGridReady"
                    >
                    </AgGridVue>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
    name: "Reminders",
    components: {
        AgGridVue,
    },
    data() {
        return {
			dismissCountDown: 0,
			dismissSecs: 5,
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [
                { headerName: "Due Date", width: '140px', cellClass: 'ag-left-aligned-cell', field: "due_date", filter: 'agDateColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Subject", width: '600px', cellClass: 'ag-left-aligned-cell', field: "subject", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Message", width: '300px', cellClass: 'ag-left-aligned-cell', field: "message", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Delete", width: '100px', field: "id", cellClass: 'ag-right-aligned-cell', 
                  cellRenderer: () => { return `<button>Delete</button>`},
                  onCellClicked: (r) => this.cancella(r.data.id),
                },
            ],
            reminders: [],
			firstPaint: false,
        };
    },
    props: {
    },
    async mounted() {
        await this.loadData()
    },
    computed: {
    },
    methods: {
        async cancella(id){
            console.log({id},"!!")
            await API.reminders(id);
            this.loadData()
        },
        async loadData(){
            let reminders = await API.reminders();
            this.reminders = reminders.data
            console.log("reminders", this.reminders);
        },
        dateFormatter(params) {
            // console.log("???", params);
            return params.value.toLocaleDateString();
        },
        onGridReady(params) {
			console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
			this.columnApi.applyColumnState({
				state: [{ colId: 'due_date', sort: 'asc' }],
				defaultState: { sort: null },
			});
        },
    },
};
</script>
<style>
div.reminders button {
    background-color: #6b1106;
    color: #fff;
    height: 40px;
}
div.dlgtable div.row:nth-child(even){
    background-color: #fafafa;
}
div.reminders td,
div.reminders th {
    text-align: left;
}
div.reminders td , div.reminders th{
    text-align: left;
}
div.reminders div.mb-0 {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}
.ag-left-aligned-cell {
    text-align: left;
}
</style>
<style scoped>
</style>
